import styled from 'styled-components/macro';

import Button from 'components/Button/Button';
import FlexContainer from 'components/FlexContainer/FlexContainer';
import Typography from 'components/Typography/Typography';

export const getPopupContentStyle = (isMobile: boolean) => ({
  width: isMobile ? '100%' : '630px',
  height: isMobile ? '100%' : 'auto',
  padding: '1.5rem 0 2.25rem',
  maxHeight: window.matchMedia('(orientation: landscape)').matches ? '95vh' : '100vh',
  overflow: 'auto',
});

export const FormStyled = styled.form`
  width: 80%;
`;

export const FormElementWrapStyled = styled.div`
  width: 100%;
  margin-bottom: 1rem;
`;

export const FormRowWrapStyled = styled(FlexContainer)`
  flex-direction: column;
  ${({ theme }) => `
    ${theme.devices.tablet} {
      flex-direction: row;
      align-items: flex-start;
      gap: 1rem;
    }
  `}
`;

export const TypographyTitleStyled = styled(Typography)`
  margin-bottom: 1.875rem;
`;

export const FlexContainerMessageStyled = styled(FlexContainer)`
  ${({ theme }) => `
    ${theme.devices.tablet} {
      padding: 0 2.5rem 0.625rem;
    }
  `}
`;

export const ActionBtnStyled = styled(Button)`
  height: 48px;
  flex: 1 1;
  font-size: ${({ theme }) => theme.fontSize['2xl']};

  &:first-child {
    margin-right: 1rem;
  }

  ${({ theme }) => `
    ${theme.devices.tablet} {
      height: 38px;
      font-size: ${theme.fontSize.lg};
    }
  `}
`;

export const CtaContainerStyled = styled(FlexContainer)`
  margin-top: 1rem;
`;
